var map = {
	"./noBordersBooks-01.webp": 9110,
	"./noBordersBooks-02.webp": 4583,
	"./poster1.webp": 370,
	"./poster2.webp": 4339,
	"./poster3.webp": 640,
	"./toCulture-01.webp": 9949,
	"./toCulture-02.webp": 7120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7770;